import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
    Button, Col, Card, Tabs,
} from 'antd';
import BikeConfigure from './BikeConfigure';
import BikeVariants from './BikeVariants';
import BikeVariantsN from './BikeVariantsN';

const { TabPane } = Tabs;

export default class BikeDetail extends Component {
    state = {
        activeTab: '1',
    };

    toggle = tab => this.state.activeTab !== tab && this.setState({ activeTab: tab });

    render() {
        const { activeTab } = this.state; const
            {
                model_id, model, brand, cc, variation, variant_create_access,
            } = this.props;
        return (
            <Col span={24}>
                <Card className="border-shadows">
                    <Tabs defaultActiveKey={activeTab} onChange={this.toggle}>
                        <TabPane tab="Configure" key="1">
                            <BikeConfigure />
                        </TabPane>
                    </Tabs>
                </Card>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '3%' }}>
                    <h3 className="page-title-variant">Model Variants</h3>
                    <div>
                        {variant_create_access ? (
                            <span style={{
                                marginRight: 10, fontStyle: 'italic', fontSize: 12, color: 'red',
                            }}
                            >
                                No Access Rights
                            </span>
                        ) : null}
                        <Button type="primary" disabled={variant_create_access}>
                            <Link to={{
                                pathname: '/PlatformManagement/Bike_variant_create',
                                state: {
                                    model, model_id, brand, cc, variation,
                                },
                            }}
                            >
                                Add New Variant
                            </Link>
                        </Button>
                    </div>
                </div>
                {/* {activeTab === "1" && <BikeVariants model_id={model_id} model={model}/>} */}
                {activeTab === '1' && <BikeVariantsN model_id={model_id} model={model} />}
            </Col>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/components/BikeDetail.js